import { organizationEndpoints } from '../../services/api/endpoints/organisation.endpoint';
import { userEndpoints } from '../../services/api/endpoints/user.endpoint';
import { CreateUserDTO } from '../../types/user';

export const createOrgUser = async (
  userData: CreateUserDTO,
  usePublicEndpoint: boolean = false
) => {
  if (usePublicEndpoint) {
    // Use public endpoint for initial user creation during activation
    // This is used for OAuth users who may not have a valid session
    await userEndpoints.createInitialUser(userData.orgId!, userData);
  } else {
    await userEndpoints.createUser(userData.orgId!, userData);
  }
};

// Export a constant function called OrgLongPolling that takes in a string parameter called orgId and returns a Promise of a boolean
export const orgLongPolling = async (orgId: string): Promise<boolean> => {
  // Return a new Promise
  return new Promise((resolve, reject) => {
    const interval = setInterval(async () => {
      try {
        const statusResponse = await organizationEndpoints.getActiveteOrganisations(orgId);
        const orgStatus = statusResponse[0]?.status;
        if (orgStatus === 'active') {
          clearInterval(interval);
          resolve(true);
        }
        if (orgStatus !== 'pending') {
          clearInterval(interval);
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    }, 10000);
  });
};
